import { createEndpoint } from '@/shared/models/api';
import { IdValue } from '@/app/api/morgan-thermal';

export type Country = IdValue;

export const getCountries = createEndpoint<Country[]>(({ fetch }) => () => fetch('/Configuration/GetCountries'));